import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import { SpeakerNotes } from 'material-ui-icons'
import Menu, { MenuItem } from 'material-ui/Menu';
import { withRouter } from "react-router-dom";
import moment from 'moment'
import jsPDF from 'jsPDF'
import html2canvas from 'html2canvas'
import htmlDocx from 'html-docx-js/dist/html-docx';

import * as resolutionemdetails from '../../../actions/resolutiondetails';

import DeleteResolution from './deleteresolution';
import CloseVotes from './closevotes';
import VoteList from './votelist';

class CardMenu extends React.Component {

    render() {
        const ITEM_HEIGHT = 40;
        const options = [
            { id: 1, name: 'View Votes' },
            // { id: 2, name: 'View / Update' },
            { id: 2, name: 'View' },
            { id: 3, name: 'Delete' },
            { id: 4, name: 'Close Votes' },
            { id: 5, name: 'Resolution Document' },
        ];
        const { menuState, anchorEl, handleRequestClose } = this.props;
        return (
            <Menu id="long-menu"
                anchorEl={anchorEl}
                open={menuState}
                onClose={handleRequestClose}
                style={{ maxHeight: ITEM_HEIGHT * 4.5 }}
                MenuListProps={{
                    style: {
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                }}>
                {options.map(option =>
                    <MenuItem key={option.id} onClick={handleRequestClose.bind(this, option.id)}>
                        {option.name}
                    </MenuItem>,
                )}
            </Menu>
        );
    }

}

const columnData = [
    { id: 'id', numeric: false, disablePadding: false, label: 'S.No.' },
    { id: 'name', numeric: false, disablePadding: true, label: 'Resolution Name' },
    { id: 'headedBy', numeric: false, disablePadding: true, label: 'Headed By' },
    { id: 'status', numeric: false, disablePadding: true, label: 'Status' },
    { id: 'closevote', numeric: false, disablePadding: true, label: 'Close Date' },
    { id: 'action', numeric: false, disablePadding: true, label: 'Actions' },
];

class DataTableHead extends React.Component {
    static propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'checkbox'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

class ExportHTML extends React.Component {
    componentDidUpdate(prevProps, prevState) {
        const { data } = this.props
        if (data)
            this.props.generateDocPDF(data.name)
    }
    render() {
        const { data } = this.props;
        return (
            // https://wordtohtml.net/
            <div className="hidden1" style={{ height: 0, opacity: 0 }}>
                <div id="divToPrint" >
                    {data && <div id="divSet" className="flex-auto" style={{ width: '90%', fontSize: '18pt', }}>
                        <h1 style={{ textAlign: 'center' }}>Resolution Details</h1>
                        <table className="blueTable" style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '40%' }}>Title:</td>
                                    <td style={{ width: '50%' }}>{data.name}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '40%' }}>Closing Date:</td>
                                    <td style={{ width: '50%' }}>{moment(data.closevote).format('DD/MM/YYYY')}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '40%' }}>Summary:</td>
                                    <td style={{ width: '50%' }}>{data.description}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <h2>Casted Votes</h2>
                            <table className="blueTable" style={{ width: '100%', }} border="1">
                                <thead>
                                    <tr style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
                                        <th style={{ width: '3%' }}>#</th>
                                        <th style={{ width: '17%' }}>User ID</th>
                                        <th style={{ width: '20%' }}>Full Name</th>
                                        <th style={{ width: '10%' }}>Vote Type</th>
                                        <th style={{ width: '30%' }}>Comments</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.votes.map((_data, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{_data.user_id}</td>
                                                <td>{_data.user_name}</td>
                                                <td>{_data.votetype}</td>
                                                <td>{_data.comment}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <h2>Result</h2>
                            <table className="blueTable" style={{ width: '50%' }} border="1">
                                <thead>
                                    <tr style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
                                        <th style={{ width: '25%' }}>Yes</th>
                                        <th style={{ width: '25%' }}>No</th>
                                        <th style={{ width: '25%' }}>ABSTAIN</th>
                                        {/* <th style={{ width: '25%' }}>NOT VOTED</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{data.yes}</td>
                                        <td>{data.no}</td>
                                        <td>{data.abstain}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    }
                </div>
            </div>
        );
    }
}
class DataTable extends React.Component {
    handleRequestSort = (event, property) => {
        // console.log('sort property',property)
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        // console.log('this.state.data',this.state.data)

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ data, order, orderBy });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    openNotes = event => {
        // console.log('handleClick Notes', this.props);
        this.setState({ openNotesDialog: true });
    };
    onOptionMenuSelect = (data, event) => {
        this.state.resolution = data;
        this.setState({ resolution: data, menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose(data, click_id, e) {
        // console.log('handleClick', click_id);
        if (click_id == 1) {
            this.setState({ openVoteDialog: true });
        }
        else if (click_id == 2) {
            this.props.history.push('/resolution/add-resolution/' + data.id);
        }
        else if (click_id == 3) {
            this.setState({ openDeleteDialog: true });
        }
        else if (click_id == 4) {
            this.setState({ openCloseVoteDialog: true });
        }
        else if (click_id == 5) {
            this.props.setInProgress(true)
            this.setState({ mmdata: data })
        }
        this.setState({ menuState: false });
    };

    generateDocPDF(fileName) {
        this.setState({ mmdata: null, downloaded: false });
        // $(input).attr('style', "backgroundColor: 'red';width: '210mm';minHeight: '297mm';marginLeft: 'auto';marginRight: 'auto'")
        const input = '<!DOCTYPE html><html><body>' + document.getElementById('divToPrint').outerHTML + '</body></html>';
        var converted = htmlDocx.asBlob(input);
        // htmlDocx.saveAs(converted, 'test.docx');
        const url = window.URL.createObjectURL(new Blob([converted], { type: 'application/docx' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '_Resolution.docx');
        document.body.appendChild(link);
        link.click();
        this.props.setInProgress(false);

        // const pdfinput = document.getElementById('divToPrint')
        // // https://github.com/MrRio/jsPDF
        // html2canvas(pdfinput)
        //     .then((canvas, _this = this) => {
        //         document.body.appendChild(canvas);
        //         const imgData = canvas.toDataURL('image/png');
        //         // console.log(pdfinput)
        //         const pdf = new jsPDF('portrait', 'pt', 'a4');
        //         const pdfConf = {
        //             margin: 1,
        //             pagesplit: false,
        //             background: '#fff'
        //         };
        //         _this.state.mmdata = null;
        //         pdf.addHTML(canvas, 20, 20, pdfConf, () => {
        //             document.body.removeChild(canvas);
        //             // pdf.addPage();
        //             pdf.save('download.pdf');
        //         });
        //         this.props.setInProgress(false);
        //     });

    }

    closeDialog = (data) => {
        this.setState({ openDeleteDialog: false });
        this.setState({ openCloseVoteDialog: false });
        this.setState({ openVoteDialog: false });
    }
    constructor(props, context) {
        super(props, context);

        this.state = {
            anchorEl: undefined,
            menuState: false,
            openDeleteDialog: false,
            openCloseVoteDialog: false,
            openVoteDialog: false,
            order: 'asc',
            orderBy: 'calories',
            data: [],
            page: 0,
            rowsPerPage: 20,
            resolution: null,
        };
    }

    render() {
        const { filterText, resolutionDetails } = this.props
        const { menuState, anchorEl, data, order, orderBy, selected, rowsPerPage, page } = this.state;
        this.state.data = this.props.data
        // console.log('DataTable', this.state.data)
        return (
            <Paper>
                <div className="flex-auto">
                    <div className="table-responsive-material">
                        <Table className="">
                            <DataTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                rowCount={this.state.data ? this.state.data.length : 0}
                            />
                            <TableBody>
                                {/* {console.log('data', this.state.data)} */}
                                {!this.state.data ?
                                    <TableRow>
                                        <TableCell colSpan={6}/>
                                    </TableRow>
                                    :
                                    this.state.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n, index) => {
                                        return (
                                            (!filterText) || (filterText.length > 0 &&
                                                ((n.name && n.name.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.headedby && n.headedby.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.closevote && moment(n.closevote).format('DD/MM/YYYY').toLowerCase().indexOf(filterText) >= 0))) ?
                                                <TableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={n.id}
                                                >
                                                    <TableCell padding="checkbox">{(index + 1) + (page * rowsPerPage)}</TableCell>
                                                    <TableCell padding="none">{n.name}</TableCell>
                                                    <TableCell padding="none">{n.headedBy}</TableCell>
                                                    <TableCell padding="none">{n.status}</TableCell>
                                                    <TableCell padding="none">{moment(n.closevote).format('DD/MM/YYYY')}</TableCell>
                                                    <TableCell padding="none">
                                                        <IconButton aria-label="view" onClick={this.onOptionMenuSelect.bind(this, n)}>
                                                            <i className="zmdi zmdi-more-vert"></i>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                                : null
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={this.state.data ? this.state.data.length : 0}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        rowsPerPageOptions={[20, 40, 100]}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                        <CardMenu menuState={menuState} anchorEl={anchorEl}
                            handleRequestClose={this.handleRequestClose.bind(this, this.state.resolution)} />
                        <CloseVotes open={this.state.openCloseVoteDialog} id={this.state.resolution ? this.state.resolution.id : null}
                            closeDialog={this.closeDialog} committee_id={this.props.committee_id} />
                        <DeleteResolution open={this.state.openDeleteDialog} id={this.state.resolution ? this.state.resolution.id : null}
                            closeDialog={this.closeDialog} committee_id={this.props.committee_id} />
                        <VoteList open={this.state.openVoteDialog} data={this.state.resolution}
                            closeDialog={this.closeDialog} />
                        <ExportHTML data={this.state.mmdata} generateDocPDF={this.generateDocPDF.bind(this)} />
                    </div>
                </div>
            </Paper>
        );
    }
}

export default withRouter(DataTable);


// WEBPACK FOOTER //
// ./app/resolutiondetails/resolutionlist/datatable.js